'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig, httpService, $http) {

	const apiBase = apiConfig.$get().apiUrl;
	const BASE = 'invoice/parked';

    /**
     * Returns boolean if a parked invoice already exists for that order
     * @param orderId {string}
     * @return {Promise<{hasParkedInvoice: boolean}>}
     */
	function orderHasParkedInvoice(orderId) {
		if(orderId) {
			const url = `${apiBase}/${BASE}/order/${orderId}/exist`;
			return httpService.get(url, {
			    transformResponse: (data) => ({hasParkedInvoice: data === 'true'})
            })
		}

		return Promise.resolve(null);
	}

	function create(data) {
		const url = `${apiBase}/${BASE}`;
		const formData = new FormData();

		for(let key of Object.getOwnPropertyNames(data)) {
			if(data[key] instanceof File) {
				formData.append(key, data[key], data[key].name);
			} else {
				formData.append(key, data[key]);
			}
		}

		return $http.post(url, formData, {
			transformRequest: angular.identity,
			headers: {'Content-Type': undefined},
			responseType: 'text'
		});
	}

	return {
		error: function (msg) {
			growl(msg.data.error, 1);
		},
		url: apiConfig.$get().apiUrl,
        doesParkedInvoiceExists: orderHasParkedInvoice,
		create
	};
}
